import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { createQueryStringHook } from "../../../../stores/useQueryState";
import { Select } from "../../../../ui/Select/Select";

const options = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT",
];

export const useProvince = createQueryStringHook("province", "");

type ProvinceSelectProps = {
  availableProvinces: Set<string>;
  className?: string;
};

export const ProvinceSelect: FunctionComponent<ProvinceSelectProps> = ({
  availableProvinces,
  className,
}) => {
  const { t } = useTranslation();
  const [province, setProvince] = useProvince();
  return (
    <Select
      onChange={(event): void => {
        setProvince(event.target.value);
      }}
      aria-label="provinceFilter"
      className={className}
      value={province}
    >
      <option value="">{t("provinceSelect.viewAll")}</option>
      {options
        .filter((option) => availableProvinces.has(option))
        .map((option) => (
          <option key={option} value={option}>
            {t(`provinceSelect.${option}`)}
          </option>
        ))}
    </Select>
  );
};
